
export const SOURCE_LOGOS = {
	TQL: '/tql-logo.svg',
	JBHUNT: '/jb-hunt.svg',
	RXO: '/rxo.svg',
	LANDSTAR: '/landstar.svg',
}
